import { Controller } from "@hotwired/stimulus"

// Row checkboxes on the invoice table. Owns which invoices are ticked; the bulk
// actions menu (invoice-bulk) sits in the topbar, outside this element, so it
// reads `selected` through an outlet and listens for `invoice-selection:change`.
//
//   <div id="invoice-selection" data-controller="invoice-selection">
//     <input type="checkbox" data-invoice-selection-target="all" data-action="invoice-selection#toggleAll">
//     <input type="checkbox" data-invoice-selection-target="row" data-action="invoice-selection#toggle"
//            value="…" data-number="…" data-uploadable="true" data-pdf-url="…" data-upload-url="…">
//   </div>
export default class extends Controller {
  static targets = ["all", "row"]

  connect() {
    this.sync()
  }

  toggleAll() {
    this.rowTargets.forEach((box) => { box.checked = this.allTarget.checked })
    this.sync()
  }

  toggle() {
    this.sync()
  }

  // Ticked invoices, in table order (newest first).
  get selected() {
    return this.rowTargets
      .filter((box) => box.checked)
      .map((box) => ({
        id:         box.value,
        number:     box.dataset.number,
        uploadable: box.dataset.uploadable === "true",
        pdfUrl:     box.dataset.pdfUrl,
        uploadUrl:  box.dataset.uploadUrl
      }))
  }

  sync() {
    const count = this.rowTargets.filter((box) => box.checked).length

    if (this.hasAllTarget) {
      this.allTarget.checked       = count > 0 && count === this.rowTargets.length
      this.allTarget.indeterminate = count > 0 && count < this.rowTargets.length
    }

    this.dispatch("change", { detail: { count } })
  }
}
